export default __webpack_public_path__ + "static/media/Scope-14.f8868b25.png";